import React, { useEffect, useState, useRef } from 'react'
import Navbar from '../navbar/Navbar'
import { FaLocationDot } from "react-icons/fa6";
import { FaRegClock } from "react-icons/fa";
import '../main.css';
import Map from './Map';
import config from '../../config';
import { apiCall } from '../../../service';

const AddressBook = () => {

  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_MAP_KEY}`;

  const vehicleRefs = useRef([]);

  const [addressBookData, setAddressBookData] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [name, setName] = useState('');
  const [id, setId] = useState()
  const [loading, setLoading] = useState(true)
  const [render, setRender] = useState(false)
  const [isMobileMapVisible, setIsMobileMapVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); 
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const payload = {
          host: config.apiEndpoints.addressBook.host,
          endPoint: config.apiEndpoints.addressBook.url,
          method: "GET",
        }
        const response = await apiCall(payload)
        setAddressBookData(response.data.rows)
        setIsMobileMapVisible(true)
        setLoading(false)

      }
      catch (error) {
        console.error('Error fetching data:', error.message);
      }

    };

    fetchData();
  }, []);

  const filteredVehicles = addressBookData.filter((vehicle) =>
    vehicle.name.toLowerCase().includes(searchQuery.toLowerCase())
  );



  const handleVehicleData = (vehicle, index) => {
    console.log("index: ", index)
    setLatitude(vehicle.latitude);
    setLongitude(vehicle.longitude);
    setName(vehicle.name);
    setId(vehicle.id);
    setRender(!render)

    if (isMobileMapVisible && isMobile) {
      vehicleRefs.current[index].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

  }
  return (
    <div>
      <Navbar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        placeholder="Search Address..."
        showFilter={showFilter}
      />
      {
        loading ?
          // <div className='loader_main'>
          //   <div class="loader"></div>
          // </div>
          <div className="loader-wrapper">
            <div className="truck-wrapper">
              <div className="truck">
                <div className="truck-container"></div>
                <div className="glases"></div>
                <div className="bonet"></div>

                <div className="base"></div>

                <div className="base-aux"></div>
                <div className="wheel-back"></div>
                <div className="wheel-front"></div>

                <div className="smoke"></div>
              </div>
            </div>
          </div>
          :
          <div className='main_container'>
            {/* <div className='vehicle_detail'> */}
            <div className={`vehicle_detail ${isMobileMapVisible ? 'fullheight' : 'semiHeight'}`}>
              <div>
                {filteredVehicles.length > 0 ? (
                  filteredVehicles.map((vehicle, index) => (
                    <div key={index} className="vehicle_container" onClick={() => { handleVehicleData(vehicle,index) }}
                    ref={(el) => vehicleRefs.current[index] = el}>
                      <p className='vehicle_data' style={{ fontWeight: "bold", fontSize: "20px" }}>
                        <span>{vehicle.name}</span>
                      </p>
                      {
                        vehicle.address !== "" && (
                          <p className=''>
                            <span><FaLocationDot /></span>
                            <span style={{ fontWeight: "bold", marginRight: "5px" }}>Nearest Address</span>
                            :
                            <span>{vehicle.address}</span>
                          </p>
                        )
                      }
                      <p className='vehicle_data'>
                        <span style={{ marginTop: "2px" }}><FaRegClock /></span>
                        <span style={{ color: "#8fb24e" }}>{vehicle.createdAt.replace('T', ' ').split('.')[0]}</span>
                      </p>
                    </div>
                  ))
                ) : (
                  <p>No matching Address found</p>
                )}
              </div>
            </div>
            <div className={`vehicle_location ${isMobileMapVisible ? 'show' : ''}`} key={render}>
              {longitude && latitude ?
                <Map
                  latitude={+latitude}
                  longitude={+longitude}
                  index={+id}
                  name={name}
                  zoom={17}
                  googleMapURL={mapURL}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div className='mapContainer' />}
                  mapElement={<div style={{ height: `100%` }} />}
                />
                :
                <>
                  <Map
                    allCoordinates={addressBookData.map((vehicle) => ({
                      latitude: +vehicle.latitude,
                      longitude: +vehicle.longitude,
                      name: vehicle.name,
                    }))}
                    // latitude={20.5937}
                    // longitude={78.9629}
                    zoom={5}
                    googleMapURL={mapURL}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div className='mapContainer' />}
                    mapElement={<div style={{ height: `100%` }} />}
                  />

                </>
              }
            </div>
          </div>
      }

    </div>
  )
}

export default AddressBook